import { Id, Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useParams } from "react-router";
import { contactService } from "../../shared/api/contactService";
import { useDataFieldsQuery } from "../../shared/api/dataFieldService";
import { useContactView } from "../../shared/hooks/useContactView";
import { StyledSection, ViewTagsSection } from "../../shared/view";
import { ArchivedContactBanner } from "./ArchivedContactBanner";
import { ArchivedContactViewAddressSection } from "./ArchivedContactViewAddressSection";
import { ArchivedContactViewCompaniesSection } from "./ArchivedContactViewCompaniesSection";
import { ArchivedContactViewEmailAddressSection } from "./ArchivedContactViewEmailAddressSection";
import { ArchivedContactViewGeneralSection } from "./ArchivedContactViewGeneralSection";
import { ArchivedContactViewPhoneNumberSection } from "./ArchivedContactViewPhoneNumberSection";

export const ArchivedContactViewPage: FC = () => {
	const { currentContactView, isLoading } = useContactView();

	if (isLoading) {
		return <Loading />;
	}

	if (!currentContactView) {
		return null;
	}

	return <ArchivedContactViewContent contactViewId={currentContactView.id} />;
};

const ArchivedContactViewContent: FC<{ contactViewId: Id }> = ({ contactViewId }) => {
	const { id = "" } = useParams<"id">();
	const { data: contact, isLoading: isContactLoading } = useQuery({
		queryKey: [...contactService.showKey(id), `${contactViewId}`],
		queryFn: () => contactService.show(id, `${contactViewId}`).then((x) => x.data.data),
	});
	const { data: dataFields, isLoading: isDataFieldsLoading } = useDataFieldsQuery();

	const isLoading = isContactLoading || isDataFieldsLoading;

	return (
		<>
			{contact && contact.archivedByTenants.length > 0 && <ArchivedContactBanner id={contact.id} />}
			<StyledSection color="content">
				{isLoading || !contact ? (
					<Loading />
				) : (
					<>
						<ArchivedContactViewGeneralSection contact={contact} dataFields={dataFields} />
						<ArchivedContactViewEmailAddressSection contact={contact} />
						<ArchivedContactViewPhoneNumberSection contact={contact} />
						<ArchivedContactViewAddressSection contact={contact} />
						<ArchivedContactViewCompaniesSection contact={contact} />
						<ViewTagsSection tags={contact.tags} />
					</>
				)}
			</StyledSection>
		</>
	);
};
